export const KIWIFY_PRODUCT_URL = "https://pay.kiwify.com.br/fuvPJn1";
export const KIWIFY_PRODUCT_URL_ANNUAL = "https://pay.kiwify.com.br/Zyfotu1";